module.exports = __webpack_public_path__ + "img/no_data@1x.ec8c4d37.png";